import React, {useEffect, useState} from 'react';
import {IonCol, IonIcon, IonItem, IonLabel, IonList, IonLoading} from "@ionic/react";
import {Links} from "@app/links";
import {useHistory} from "react-router-dom";
import Pane from "@components/pane/pane.component";
import SupportRequestModal from "@modals/supportRequest/supportRequest.component";
import ReportProblemImageActive from "@assets/images/report-problem-active.svg";
import {useTranslation} from "react-i18next";
import {Preferences} from "@capacitor/preferences";
import {getWorkerWorkerFormSettings} from "@services/worker.service";

type HelpdeskSubMenuModalProps = {
    topEdge?: number,
}

const HelpdeskSubMenuModal: React.FC<HelpdeskSubMenuModalProps> = ({topEdge}: HelpdeskSubMenuModalProps) => {
    const {t} = useTranslation();
    const history = useHistory();

    const [basketAvailable, setBasketAvailable] = useState<boolean>(false);
    const [showLoader, setShowLoader] = useState<boolean>(false);
    const [showSupportRequest, updateShowSupportRequest] = useState<boolean>(false);
    const [requestHr, setRequestHr] = useState<boolean>(false);
    useEffect(() => {
        handleStart();
        fetchWorkerWorkerFormSettings();
    }, []);

    const handleStart = async () => {
        const basketAvailableValue = await Preferences.get({'key': 'worker_form_basket_available'});
        setBasketAvailable(basketAvailableValue.value === '1');
    };
    const redirectReportProblem = async () => {
        history.push(Links.main + Links.helpdesk.reportProblem);
    }
    const redirectReportApplication = async () => {
        history.push(Links.main + Links.helpdesk.reportApplication);
    }
    const redirectReportApplications = async () => {
        history.push(Links.main + Links.helpdesk.reportApplicationList);
    }
    const fetchWorkerWorkerFormSettings = async () => {
        const workerWorkerFormSettingsData = await getWorkerWorkerFormSettings();
        setRequestHr(workerWorkerFormSettingsData.ep2_helpdesk_reporting_enabled)
    }

    return (
        <>
            <IonLoading onDidDismiss={() => setShowLoader(false)} isOpen={showLoader}/>
            <Pane topEdge={topEdge}>
                <IonList style={{'paddingRight': '20px', 'paddingTop': '10px'}}>
                    {
                        <IonItem key={1} onClick={() => updateShowSupportRequest(true)}>
                            <IonCol size='2' style={{'textAlign': 'center'}}>
                                <IonIcon src={ReportProblemImageActive} className="active"
                                         style={{"fontSize": "20px", "color": '#888A98'}}/>
                            </IonCol>
                            <IonLabel>
                                {t("helpdesk.requestJira")}
                            </IonLabel>
                        </IonItem>
                    }
                    {requestHr &&
                        <IonItem key={2} onClick={() => redirectReportProblem()}>
                            <IonCol size='2' style={{'textAlign': 'center'}}>
                                <IonIcon src={ReportProblemImageActive} className="active"
                                         style={{"fontSize": "20px", "color": '#888A98'}}/>
                            </IonCol>
                            <IonLabel>
                                {t("helpdesk.requestHr")}
                            </IonLabel>
                        </IonItem>
                    }
                    {basketAvailable &&
                        <IonItem key={3} onClick={() => redirectReportApplications()}>
                            <IonCol size='2' style={{'textAlign': 'center'}}>
                                <IonIcon src={ReportProblemImageActive} className="active"
                                         style={{"fontSize": "20px", "color": '#888A98'}}/>
                            </IonCol>
                            <IonLabel>
                                {t("helpdesk.requestReportApplication")}
                            </IonLabel>
                        </IonItem>
                    }
                </IonList>
            </Pane>
            <SupportRequestModal isOpen={showSupportRequest} onClose={() => updateShowSupportRequest(false)}/>
        </>
    );
};

export default HelpdeskSubMenuModal;